import {Component, computed, inject, input, ChangeDetectionStrategy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Api} from '../../../../api/api';
import {getTodaysPlannedYield, getTomorrowsPlannedYield} from '../../../../api/functions';
import {rxResource} from '@angular/core/rxjs-interop';
import {catchError, from, of} from 'rxjs';
import {LocationStateService} from '../../../../common/services/location-state.service';

export type PvYieldDay = 'today' | 'tomorrow';

@Component({
  selector: 'app-pv-yield',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './pv-yield.component.html',
})
export class PvYieldComponent {
  api = inject(Api);
  locationStateService = inject(LocationStateService);

  day = input.required<PvYieldDay>();
  // nur den Wert (ohne Label/Rahmen) rendern, z.B. eingebettet in die Wetter-Kacheln
  valueOnly = input(false);
  label = computed(() => (this.day() === 'today' ? 'Erw. PV-Ertrag heute:' : 'Erw. PV-Ertrag morgen:'));

  params = computed(() => ({
    location_id: this.locationStateService.currentLocation()?.id ?? '',
    day: this.day(),
  }));
  resource = rxResource({
    params: this.params,
    stream: ({params}) => {
      const fn = params.day === 'today' ? getTodaysPlannedYield : getTomorrowsPlannedYield;
      return from(this.api.invoke(fn, {location_id: params.location_id})).pipe(
        catchError((error) => {
          console.log('PV yield API does not respond.', error);
          return of(undefined);
        }),
      );
    },
  });
  yieldKwh = computed(() => this.resource.value()?.yieldKwh);
}
